import React, { FunctionComponent } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import gray from '@material-ui/core/colors/grey';
import moment from 'moment';
type CommentNodeProps = {
    user: string;
    timestamp: string;
    text: string;
};
const useStyles = makeStyles({
    commentUserName: {
        textAlign: 'left',
        paddingRight: 20,
        marginBottom: '1%',
        fontWeight: 600,
        color: gray[800],
        fontSize: 14,
    },
    commentDate: {
        width: '50%',
    },
    commentNodeText: {
        width: '100%',
        wordWrap: 'break-word',
    },
    commentNode: {
        width: '83%',
        justifySelf: 'center',
        marginBottom: '30px',
        fontSize: 14,
        color: gray[600],
        lineHeight: '20px',
        minWidth: 100,
    },
});
const CommentNode: FunctionComponent<CommentNodeProps> = (props) => {
    const { text, user, timestamp } = props;
    //@ts-ignore
    const classes = useStyles();
    return (
        <Grid container className={classes.commentNode}>
            <Grid container>
                <Grid item className={classes.commentUserName}>
                    {user}
                </Grid>
                <Grid item className={classes.commentDate}>
                    {moment(timestamp).format('LLL')}
                </Grid>
            </Grid>
            <Grid item className={classes.commentNodeText}>
                {text}
            </Grid>
        </Grid>
    );
};
export default CommentNode;
